<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "CreduContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("credu_listar")) {
				m.push({
					titulo: "Credu",
					titulo_app: "Credu",
					icon: "mdi-store-outline",
					to: "/credu",
					tooltip: "Lista clientes em inadimplência",
				});
			}

			if (this.permissao("credu_lancamento")) {
				m.push({
					titulo: "Lançamento",
					titulo_app: "Lançamento",
					icon: "mdi-store-outline",
					to: "/credu/lancamento",
					tooltip: "Tela de baixa de clientes inadiplêntes",
				});
			}

			if (this.permissao("credu_dashboard")) {
				m.push({
					titulo: "Dashboard",
					titulo_app: "Dashboard",
					icon: "mdi-store-outline",
					to: "/credu/dashboard",
					tooltip: "Dashboard de clientes inadiplêntes",
				});
			}

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>